import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {CommonService} from './common.service';

@Injectable({
    providedIn: 'root'
})
export class EditorService {
    dialogConfig = {
        position: {right: '0', top: '0'},
        width: '600px',
        height: '100%',
        data: {},
        hasBackdrop: false,
        panelClass: 'slide-from-right-dialog'
    };
    templates = [];

    constructor(public dialog: MatDialog,
                private commonService: CommonService) {
    }

    initializeForm(data) {
        const settings = JSON.parse(data.settings);
        if (!settings.hasOwnProperty('language')) {
            settings.language = {
                multi: false,
                languages: [{id: 1, value: 'EL'}, {id: 2, value: 'EN'}],
                default: 1,
                preview: 1,
                position: 'end center'
            };
        }
        const rows = JSON.parse(data.rows);
        for (const row of rows) {
            if (!row.title.hasOwnProperty('textEN')) {
                row.title.textEN = '';
            }
            for (const member of row.members) {
                if (!member.hasOwnProperty('displayOnTable')) {
                    member.displayOnTable = false;
                }
                if (!member.hasOwnProperty('valueEN')) {
                    member.valueEN = '';
                }
                if (!member.hasOwnProperty('labelEN')) {
                    member.labelEN = '';
                }
                if (!member.hasOwnProperty('placeholderEN')) {
                    member.placeholderEN = '';
                }
            }
        }
        // for (const row of rows) {
        //     if (!row.hasOwnProperty('isLinked')) {
        //         row.isLinked = false;
        //     }
        // }
        const questions = JSON.parse(data.questions);
        return {settings, rows, questions, uniqueId: data.uniqueId};
    }

    async initializeTemplates() {
        this.templates = [];
        const templates = await this.fetchTemplates();
        for (const template of templates) {
            this.templates.push({id: template.id, name: template.name, rows: JSON.parse(template.rows)});
        }
    }

    async fetchTemplates(): Promise<any> {
        const templates = await this.commonService.getList('resumes/templates');
        return templates.object;
    }

    async saveForm(form: any): Promise<any> {
        await this.commonService.insertItem('resumes', form);
    }

    async updateForm(form: any, uniqueId: string): Promise<any> {
        await this.commonService.updateItem(`resumes/${uniqueId}`, form);
    }

    async createTemplate(template: any): Promise<any> {
        await this.commonService.insertItem('resumes/templates', template);
    }

    //#region Helpers
    createRow(id: number, columns: number): any {
        const members = [];
        const title = {
            text: '',
            textEN: '',
            color: '#000000',
            margin: '0px'
        };
        for (let i = 0; i < columns; i++) {
            members.push(this.createMember(i + 1));
        }
        return {
            id,
            columns,
            title,
            members
        };
    }

    createMember(id) {
        return {
            id,
            twoFactor: {
                isTwoFactorField: false,
                types: ['sms', 'email'],
                selectedType: ''
            },
            key: null,
            type: null,
            label: null,
            labelEN: null,
            labelColor: '#000000',
            hiddenValue: '',
            placeholder: null,
            placeholderEN: null,
            controls: [],
            shouldExport: false,
            isHidden: false,
            value: '',
            valueEN: '',
            options: [],
            displayOnTable: false,
            isRequired: false,
        };
    }

    //#endregion
}
